import Swal from "sweetalert2";

const DeleteConfirmation = (
  onDelete,
  text = "You won't be able to revert this!",
  title = "Are you sure?"
) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "No, cancel!",
    customClass: {
      container: "swal2-container-higher-zindex",
    },
    zIndex: 20000,
  }).then((result) => {
    if (result.isConfirmed && onDelete) {
      onDelete();
    }
  });
};

export default DeleteConfirmation;
